import { useContext, useEffect, useState } from "react";
import MainContext from "../../../context/mainContext";
import { Box } from "@mui/material";
import MyInboxTitle from "./MyInboxTitle";
import styles from "./MyInboxPublications.module.scss";
import MyInboxPublications from "./MyInboxPublications";

const MyInbox: React.FC = () => {
  const { setBanner } = useContext(MainContext);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setBanner("drone-beach.png");
  });

  const handleRefreshAction = () => {
    setRefresh(!refresh);
  };

  return (
    <Box className={styles.myInboxMain}>
      <MyInboxTitle />
      <MyInboxPublications
        status="InProgress"
        refresh={refresh}
        onRefreshAction={handleRefreshAction}
        showBack
        showWorkflowTypesReference
      />
      <MyInboxPublications
        status="Completed"
        refresh={refresh}
        onRefreshAction={handleRefreshAction}
      />
    </Box>
  );
};

export default MyInbox;
